import { inoutLocalDay } from '@tonnie/heroes';

/**
 * The calendar day on this device — the public calculator's `today` (the
 * calculator schema takes the client's day, as the dashboard reads the
 * person's own). Signed-in screens never send a day: the server reads the
 * person's time zone.
 */
export function deviceToday(now: Date = new Date()): string {
  // The device's own calendar fields — its time zone's day, as `YYYY-MM-DD`.
  return inoutLocalDay(now);
}

/** The year on this device — where a calendar's year dropdown is centred. */
export function deviceYear(now: Date = new Date()): number {
  return Number(deviceToday(now).slice(0, 4));
}

/** How far a calendar reaches from this year: a title issued years back, a trip long ago. */
export const CALENDAR_YEARS = 15;
